import React from 'react';
import { formatVariableName } from '../../../../utils/nameUtils';
import type { ValidationStepProps } from '../types';

/**
 * Validation step for campaign creation.
 * Shows missing template variables and offers resolution options.
 */
export const ValidationStep: React.FC<ValidationStepProps> = ({
  missingVars,
  onEnrichData,
  onChooseAnotherTemplate,
  onContinueAnyway,
}) => {

  return (
    <div className="mt-3">
      {/* Variable table */}
      <div className="border border-gray-200 rounded-lg overflow-hidden mb-3">
        <div className="bg-gray-50 px-3 py-2 border-b border-gray-200 grid grid-cols-2 gap-4">
          <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wide">
            Variable
          </span>
          <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wide">
            Status
          </span>
        </div>
        <div className="divide-y divide-gray-100">
          {missingVars.map((v) => (
            <div key={v.variable} className="px-3 py-2 grid grid-cols-2 gap-4">
              <span className="text-[12px] font-medium text-gray-700">
                {formatVariableName(v.variable)}
              </span>
              <span className="text-[12px] text-amber-600">
                {v.status === 'missing'
                  ? 'Column not found'
                  : `${v.populatedCount}/${v.totalCount} have data`}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => {
            if (onEnrichData && missingVars.length > 0) {
              onEnrichData(missingVars.map((v) => v.variable));
            }
          }}
          disabled={!onEnrichData}
          className="px-3 py-1.5 text-[12px] text-gray-700 bg-white border border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Enrich data
        </button>
        <button
          type="button"
          onClick={onChooseAnotherTemplate}
          className="px-3 py-1.5 text-[12px] text-gray-700 bg-white border border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition-all"
        >
          Choose another template
        </button>
        <button
          type="button"
          onClick={onContinueAnyway}
          className="px-3 py-1.5 text-[12px] text-gray-700 bg-white border border-gray-200 rounded-lg hover:border-gray-300 hover:bg-gray-50 transition-all"
        >
          Continue anyway
        </button>
      </div>
    </div>
  );
};

ValidationStep.displayName = 'ValidationStep';
